import { AlertPayload } from "contexts/alert";
import React, { useEffect, useState } from "react";
import WishlistService from "services/wishListService";
import {
    BoxRanger, BoxRangerText, DropDown,
    Input, InputBoxSelection
} from "superbid-ui";
import formatPrice from "../../commons/utils/Utils";
import { AutoComplete } from "../AutoComplete";
import { ModalTitle } from "../ModalTitle";
import { ActionButtons } from "./actionButtons";
import styles from "./formAlert.module.scss";

interface FormAlertProps {
    aoEnviar: any;
    handleClose: any;
    open?: any;
    data?: AlertPayload;
    type?: any;
    formCategory?: "carros-motos" | "outros";
}

export const FormAlert: React.FC<FormAlertProps> = ({
    aoEnviar,
    handleClose,
    data,
    type,
    formCategory,
}) => {
    const [id, setId] = useState("");
    const [brand, setBrand] = useState("");
    const [model, setModel] = useState("");
    const [shortDesc, setShortDesc] = useState("");
    const [formInputValue, setFormInputValue] = useState("");
    const [minPrice, setMinPrice] = useState(0);
    const [maxPrice, setMaxPrice] = useState(500000);
    const [startYear, setStartYear] = useState(1950);
    const [endYear, setEndYear] = useState(new Date().getFullYear());
    const [pricePlace, setPricePlace] = useState("Preço");
    const [yearsPlace, setYearsPlace] = useState("Ano");
    const [placeHolderLocation, setPlaceHolderLocation] =
        useState("Todas as cidades");
    const [userSelectedData, setUserSelectedData] = useState([]);
    const [isErroredInput, setIsErroredInput] = useState(false);
    const today = new Date();
    const year = today.getFullYear();
    const [inputValueSearch, setInputValueSearch] = useState("");
    const [locationsList, setLocationsList] = useState([]);
    const [locationSelection, setLocationSelection] = useState<any>([]);

    useEffect(() => {
        if (type === "edit") {
            setId(data._id);
            setBrand(data.product.brand);
            setModel(data.product.model);
            setShortDesc(data.product.shortDesc);
            setFormInputValue(`${data.product.brand} ${data.product.model}`);
            setYearsPlace(
                `de ${data.product.yearMin} a ${data.product.yearMax}`
            );
            setEndYear(data.product.yearMax);
            setStartYear(data.product.yearMin);
            setMinPrice(data.product.priceMin);
            setMaxPrice(data.product.priceMax);
            setPricePlace(
                `de ${formatPrice.toBRL(
                    data.product.priceMin
                )} a ${formatPrice.toBRL(data.product.priceMax)}`
            );

            if (data?.product?.location[0]?.city) {
                setUserSelectedData([
                    `${data.product.location[0].city}-${data.product.location[0].state}`,
                ]);
            }

            if (
                !data?.product?.location[0]?.city &&
                data?.product?.location[0]?.state
            ) {
                setUserSelectedData([`${data?.product?.location[0]?.state}`]);
            }
        }
    }, [type]);

    const handleSearchLocation = async (e: any) => {
        const value = typeof e === "string" ? e : e.target.value;

        setInputValueSearch(value);
        const locationsArr = [];
        try {
            const wishListService = new WishlistService();
            const { data } = await wishListService.getLocation(value);

            data?.map((item) => {
                locationsArr.push({
                    id: Math.random() * (5580 - 0) + 0,
                    sigla: item.sigla,
                    category: item.stateName,
                    items: item.cities.map((city) => {
                        return `${city}-${item.sigla}`;
                    }),
                });
            });
            setLocationsList(locationsArr);
        } catch (error) {
            console.log(error.response);
        }
    };

    const handleUserLocationSelection = (
        selectedLocation: any,
        selectionObj: any
    ) => {
        let tempObj;

        if (!selectedLocation && !selectedLocation) {
            setLocationSelection([]);
            return;
        }

        if (selectedLocation.length) {
            const city = selectedLocation.substring(
                0,
                selectedLocation.length - 3
            );
            tempObj = {
                city,
                state: selectionObj.category,
            };
        } else {
            tempObj = {
                state: selectionObj.category,
                city: "",
            };
        }

        setLocationSelection([tempObj]);
    };

    return (
        <div className={styles.box}>
            <ModalTitle
                title={
                    type === "create" ? "Crie seu alerta" : "Edite seu alerta"
                }
                subtitle={
                    "Preencha o formulário e te avisaremos quando o seu produto estiver disponível. "
                }
            />
            <form
                onSubmit={(event) => {
                    event.preventDefault();
                    if (formCategory === "carros-motos" && !formInputValue) {
                        setIsErroredInput(true);
                        return;
                    }

                    if (formCategory === "carros-motos" && !model) {
                        setIsErroredInput(true);
                        return;
                    }

                    if (formCategory === "outros" && !shortDesc) {
                        setIsErroredInput(true);
                        return;
                    }

                    aoEnviar({
                        id,
                        product: {
                            category: formCategory,
                            location: locationSelection,
                            priceMax: maxPrice || 500000,
                            priceMin: minPrice,
                            brand: brand,
                            shortDesc: formCategory === "outros" && shortDesc,
                            model: model,
                            yearMin: startYear,
                            yearMax: endYear,
                        },
                    });
                }}
            >
                <div className={styles.box__form}>
                    <div className={styles.box__form__input_search}>
                        {formCategory === "carros-motos" && (
                            <AutoComplete
                                isErrored={isErroredInput}
                                placeholder={"Marca ou o modelo do carro"}
                                name={"brand"}
                                value={formInputValue}
                                onChange={(value) => {
                                    setBrand(value);
                                    setFormInputValue(value);
                                    setIsErroredInput(false);
                                }}
                                onClick={(value) => {
                                    setBrand(`${value.brand}`);
                                    setModel(value.model);
                                    setFormInputValue(
                                        `${value.brand} ${value.model}`
                                    );
                                }}
                                tagDelete={() => {
                                    setBrand("");
                                    setModel("");
                                    setFormInputValue("");
                                }}
                            />
                        )}
                        {formCategory === "outros" && (
                            <Input
                                value={shortDesc}
                                placeholder={
                                    "Digite o item que deseja (Ex: cadeira gamer)"
                                }
                                onChange={(text) => {
                                    setShortDesc(text);
                                    setIsErroredInput(false);
                                }}
                                isErrored={isErroredInput}
                            />
                        )}
                    </div>
                    <div className={styles.box__form__group_action}>
                        <div className={styles.box__form__group_action__input}>
                            <DropDown
                                type={"price"}
                                className={styles.dropdown}
                                placeholder={pricePlace}
                            >
                                {formCategory === "carros-motos" ? (
                                    <BoxRanger
                                        minRanger={0}
                                        maxRanger={500000}
                                        onChange={({
                                            min,
                                            max,
                                        }: {
                                            min: number;
                                            max: number;
                                        }) => {
                                            setMinPrice(min);
                                            setMaxPrice(max);
                                            setPricePlace(
                                                `de ${formatPrice.toBRL(
                                                    min || 0
                                                )} a ${formatPrice.toBRL(
                                                    max || 0
                                                )}`
                                            );
                                        }}
                                        defaultValue={[
                                            minPrice || 0,
                                            maxPrice || 0,
                                        ]}
                                        type={"price"}
                                        limitValue={99999999999}
                                    />
                                ) : (
                                    <BoxRangerText
                                        minRanger={0}
                                        maxRanger={null}
                                        defaultValue={[minPrice || 0, null]}
                                        limitValue={99999999999}
                                        onChange={({
                                            min,
                                            max,
                                        }: {
                                            min: number;
                                            max: number;
                                        }) => {
                                            setMinPrice(min);
                                            setMaxPrice(max);
                                            setPricePlace(
                                                `de ${formatPrice.toDecimal(
                                                    min || 0
                                                )} a ${formatPrice.toDecimal(
                                                    max || 0
                                                )}`
                                            );
                                        }}
                                    />
                                )}
                            </DropDown>
                        </div>
                        <div className={styles.box__form__group_action__input}>
                            {formCategory === "carros-motos" && (
                                <DropDown
                                    className={styles.dropdown}
                                    placeholder={yearsPlace}
                                    type={"date"}
                                >
                                    <BoxRanger
                                        minRanger={1950}
                                        maxRanger={endYear}
                                        onChange={({
                                            min,
                                            max,
                                        }: {
                                            min: number;
                                            max: number;
                                        }) => {
                                            setStartYear(min);
                                            setEndYear(max);
                                            setYearsPlace(
                                                `de ${min || 1950} a ${
                                                    max || year
                                                }`
                                            );
                                        }}
                                        type={"date"}
                                        defaultValue={[
                                            startYear || 1950,
                                            endYear || 2022,
                                        ]}
                                        limitValue={2022}
                                    />
                                </DropDown>
                            )}
                            {formCategory === "outros" && (
                                <InputBoxSelection
                                    placeholder={placeHolderLocation}
                                    dataList={locationsList}
                                    userSelectedData={userSelectedData}
                                    setUserSelectedData={setUserSelectedData}
                                    showChips={false}
                                    multipleSelection={false}
                                    inputValueSearch={inputValueSearch}
                                    onChangeInputSearch={handleSearchLocation}
                                    handleUserSelection={
                                        handleUserLocationSelection
                                    }
                                />
                            )}
                        </div>
                    </div>
                    {formCategory === "carros-motos" && (
                        <div className={styles.dropdown}>
                            <InputBoxSelection
                                placeholder={placeHolderLocation}
                                dataList={locationsList}
                                userSelectedData={userSelectedData}
                                setUserSelectedData={setUserSelectedData}
                                showChips={false}
                                multipleSelection={false}
                                inputValueSearch={inputValueSearch}
                                onChangeInputSearch={handleSearchLocation}
                                handleUserSelection={
                                    handleUserLocationSelection
                                }
                            />
                        </div>
                    )}
                </div>

                <ActionButtons styles={styles} handleClose={handleClose} />
            </form>
        </div>
    );
};
